import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=fcd8055a&"
import script from "./contract.vue?vue&type=script&lang=js&"
export * from "./contract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcd8055a')) {
      api.createRecord('fcd8055a', component.options)
    } else {
      api.reload('fcd8055a', component.options)
    }
    module.hot.accept("./contract.vue?vue&type=template&id=fcd8055a&", function () {
      api.rerender('fcd8055a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/contract.vue"
export default component.exports